import i18next from 'i18next';

import { intl } from '~lib/intl';

i18next.addResources('es_CL', 'RequestErrors', {
  STORE_CLOSED: 'El local se encuentra cerrado en este momento',
  NOT_AUTHORIZED: 'Ha ocurrido un error con su sesión. Por favor, intenta iniciar sesión nuevamente',
  DELIVERY_MINIMUM_NOT_REACHED: 'El valor del pedido es menor al mínimo requerido',
  ORDER_CREATION_BLOCKED: 'No se pudo generar la orden porque hay una en curso',
  NETWORK_ERROR: 'Ha ocurrido un error, por favor intente nuevamente más tarde',
  UNAVAILABLE_ITEMS: 'Algunos elementos presentes en la orden no están disponibles',
  Unauthorized: 'Ha ocurrido un error con su sesión. Por favor, intenta iniciar sesión nuevamente',
  timeout: 'El pedido ha superado el tiempo máximo. Por favor intente nuevamente en unos minutos.',
  MAXIMUM_CASH_PAYMENT_AMOUNT_EXCEEDED:
    'El total del pedido supera el máximo permitido para pagos en efectivo'
});

i18next.addResources('es_CL', 'APIErrors', {
  e1001: 'Ha ocurrido un error con los campos ingresados, por favor revise los datos',
  e1007: 'Ha ocurrido un error con el carrito.',
  e1010: '¡Ups! Tuvimos un problema para procesar tu pedido. Comunícate con la tienda para tomar tu orden',
  e1011: 'Algunos elementos presentes en la orden no están disponibles: {{items}}',
  e1024: 'La tienda está cerrada',
  e1026: `El monto mínimo permitido para este método de despacho es de ${intl.currencySymbol}{{value}}`,
  e1038: 'No se puede crear la orden porque ya hay una en ejecución',
  e1044: `El monto máximo permitido para este método de envío es de ${intl.currencySymbol}{{value}}`,
  e1072: 'Al quitar el producto perderás el beneficio de crear tu combo, aumentando tu monto total.',
  e1108: 'El cupón ingresado no es compatible con el medio de pago seleccionado.',
  e9999: 'Por favor intenta más tarde',
  e1030: 'La orden ya se encuentra pagada',
  e1031: 'Plataforma inválida para el pago con OnePay (WEB, MOBILE, APP)',
  e1032: 'Los estados de orden son inválidos para el pago online',
  e1033: 'No se pudo completar el pago, error de respuesta de Transbank',
  e1039: 'Ocurrió un error al crear un pago o un reembolso con Webpay',
  e1043: 'No se puede reprocesar la orden porque no está pagada ni fallida',
  e1061: 'Se superó el máximo de días para crear una orden futura',
  e1062: 'La fecha de orden futura tiene que ser mayor al tiempo establecido',
  e1091: 'El tipo de delivery no se implementa',
  e1092: 'Error en la solicitud a PedidosYa',
  e1200: 'Error interno (Middleware)',
  e1204: 'El método de pago no está disponible para esta tienda'
});

i18next.addResources('es_CL', 'APIErrorFields', {
  phoneTaken: 'Este teléfono ya está registrado, por favor usa uno distinto.'
});
